import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordPractitionerModel} from '../../../api/model/medicalRecordPractitioner.model';

@Injectable({providedIn: 'root'})
export class MedicalPractitionerRepository extends AbstractRepositoryV2<MedicalRecordPractitionerModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalPractitioner', serviceElementsFactory, injector);
    }
}
